import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/incidents/$incidentId/_layout/customers/')({});